
import { defineComponent } from 'vue'
import ZButton from '../ZButton/ZButton.vue'

export default defineComponent({
  name: 'ZNumberInput',
  components: { ZButton },
  props: {
    value: { type: [Number, String], default: NaN },
    min: { type: [Number, String], default: NaN },
    max: { type: [Number, String], default: NaN },
    step: { type: Number, default: 1 },
    jump: { type: Number, default: 5 },
    placeholder: { type: String, default: 'Enter a number' }
  },
  data() {
    return {
      localVal: Number(this.value)
    }
  },
  computed: {
    minNumber(): number {
      return Number(this.min)
    },
    maxNumber(): number {
      return Number(this.max)
    },
    localValNumber(): number {
      return Number(this.localVal)
    },
    inputListeners(): object {
      return Object.assign({}, this.$listeners, {
        input: ({ target }: InputEvent) => {
          if (target) {
            const a = this.minMaxNum((target as HTMLInputElement).valueAsNumber)
            this.localVal = a
            this.$emit('input', this.localValNumber)
          }
        }
      })
    }
  },
  methods: {
    updateNumber(e: MouseEvent, modifier: number): void {
      if (e.shiftKey) this.localVal = this.minMaxNum(this.localValNumber + this.jump * modifier)
      else this.localVal = this.minMaxNum(this.localValNumber + this.step * modifier)
      this.$emit('input', this.localValNumber)
    },
    minMaxNum(val: number): number {
      if (!isNaN(this.minNumber) && !isNaN(this.maxNumber))
        return Math.min(Math.max(val, this.minNumber), this.maxNumber)
      else if (!isNaN(this.minNumber)) return Math.max(val, this.minNumber)
      else if (!isNaN(this.maxNumber)) return Math.min(val, this.maxNumber)
      return val
    }
  }
})
